import { List, styled } from '@mui/material'

const SubListItemMenu = styled(List)(({ theme }) => ({
  paddingBottom: '10px',
  '& a .MuiTypography-root': {
    color: theme.palette.grey[300],
    fontSize: 15
  },
  '& a:hover .MuiTypography-root': {
    color: theme.palette.grey[50]
  },
  '& .MuiListItem-root': {
    padding: '0 24px 0px 55px'
  }
}))

export default SubListItemMenu
